export const isIos = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /iphone/.test(userAgent);
}